const AddForm = require('../ui/addform');
const Card = require('./card');
const CollectionManager = require('../ui/collection');
const CardService = require('../../services').Cards;
const CardSuggestion = require('../integrations/card-suggestion');
const ToggledIntro = require('../ui/toggled-intro');
const ToggledMenu = require('../ui/toggled-menu');
const BuyLink = require('../ui/buy-link');
const template = require('./decklist.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;

	this.specialCards = [];
	
	var onchange = on(_t, 'change').fire(_t);

	var refreshTimer = null;
	var refresh = function() {
		if (refreshTimer) return;
		refreshTimer = setTimeout(function() {
			_t.readSpecialCards();
			refreshTimer = null;
			consolidate();
			recount();
			_t.buy.load(_t.cards);
			onchange.fire(_t);
		}, 1);
	};

	this.toJSON = () => ({
		cards: [...this.cards],
		commander: this.commander
	});

	this.setTactics = function(tacticOptions) {
		this.cards.forEach(function(card) {
			card.setTacticOptions(tacticOptions);
			card.refresh();
			recount();
		});
		this.commander?.setTacticOptions?.(tacticOptions);
		this.commander?.refresh?.();
	};

	this.lock = function() {
		this.classList.add('locked');
		this.cards.forEach(function(card) { card.lock(); });
		this.editRawLink = "view raw";
	};

	this.unlock = function() {
		this.classList.remove('locked');
		this.cards.forEach(function(card) { card.unlock(); });
		this.editRawLink = "edit raw";
	};

	var matchByName = function(card) {
		return function(item) {
			return item.name.toLowerCase() == card.name.toLowerCase();
		};
	};

	var consolidate = function() {
		_t.cards.reduce(function(reduced, card) {
			var matches = reduced.filter(matchByName(card));
			if (matches.length > 0) {
				var match = matches[0];
				match.quantity = Number(match.quantity) + Number(card.quantity);
				match.sideboarded = Number(match.sideboarded) + Number(card.sideboarded);
				card.remove();
			} else {
				reduced.push(card);
			}
			return reduced;
		}, []);
	};

	this.expandLink.onclick = function() {
		_t.cards.forEach(function(c) { c.show(); });
	};

	this.collapseLink.onclick = function() {
		_t.cards.forEach(function(c) { c.hide(); });
	};

	this.sortLink.onclick = function() {
		_t.cards.sort(function(a,b) {
			return b.activeQuantity - a.activeQuantity
				|| (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
			;
		});
		on(manager, 'change').fire();
	};

	this.editRawLink.onclick = () => {
		typeof this.editRaw === 'function' && this.editRaw();
	};

	var recount = function() {
		_t.count = _t.cards.reduce(function(sum, card) {
			return sum + Number(card.activeQuantity);
		}, 0);

		_t.sideboarded = _t.cards.reduce(function(sum, card) {
			return sum + Number(card.sideboarded);
		}, 0);
	}; // recount()

	this.addform.findSuggestions = function(card) {
		return CardService.getIndex(card.name, '', 10).then(function(results) {
			return results.map(function(r) { return new CardSuggestion({
				name: r, quantity: card.quantity || 1
			})});
		});
	};

	var manager = new CollectionManager(
		this.cards, this.addform, Card, null
	);
	on(manager, 'change').then(refresh);
	on(manager, 'add').then(card => {
		on(card, 'togglecommander').then(() => {
			card.promoteToCommander();
			manager.remove(card);
			this.setCommander(new Card(
				{
					name: card.name,
					quantity: 1,
					tactics: card.tactics,
					isCommander: true
				}
			));
			this.commander.refresh();
		});
	});

	this.demoteCommander = () => {
		if (!this.commander) return;
		manager.add({
			name: this.commander.name,
			quantity: 1,
			tactics: this.commander.tactics
		});
		this.commander = null;
		this.specialCards = [];
	};

	this.setCommander = commander => {
		if (commander) {
			on(commander, 'togglecommander').then(() =>  this.demoteCommander());
			on(commander, 'change').then(() => refresh());
			on(commander, 'rename').then(() => refresh());
			on(commander, 'remove').then(() => {
				this.commander = null;
				this.specialCards = [];
				refresh();
			})
			refresh();
		}
		this.commander = commander;
		this.specialCards = [this.commander];
	};

	this.displayedCommander = () => {
		return this.specialCards.filter(c => c.isCommander).pop();
	};

	this.readSpecialCards = () => {
		if (this.commander && !this.displayedCommander()) {
			this.setCommander(new Card({
				...(this.commander || {}),
				isCommander: true
			}));
		}
	};

	ToggledIntro.call(this.intro, manager);
	ToggledMenu.call(this.menu, manager);

});
